const LOGIN_START_TIME_KEY = 'loginStartTime';

export const recordLoginStartTime = (): void => {
    sessionStorage.setItem(LOGIN_START_TIME_KEY, String(Date.now()));
};

export const getLoginDurationInMs = (): number | undefined => {
    const startTime = sessionStorage.getItem(LOGIN_START_TIME_KEY);
    if (!startTime) return undefined;

    return Date.now() - Number(startTime);
};
